import { render, staticRenderFns } from "./highCostPatientDetails.vue?vue&type=template&id=7d1bc243"
import script from "./highCostPatientDetails.vue?vue&type=script&lang=js"
export * from "./highCostPatientDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports